import { render, staticRenderFns } from "./PageSummaryConfigForm.vue?vue&type=template&id=e724699c"
import script from "./PageSummaryConfigForm.vue?vue&type=script&lang=js"
export * from "./PageSummaryConfigForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports